// Added by Sejune Oh on 2019-03-22
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { useState } from 'react'
import { WithTheme, withTheme } from '@material-ui/core'
import { InputProps as StandardInputProps } from '@material-ui/core/Input'
import { FilledInputProps } from '@material-ui/core/FilledInput';
import { OutlinedInputProps } from '@material-ui/core/OutlinedInput';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { ReactKeyUpEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime Elements
import { InputAdornment, IconButton, VisibilityIcon, VisibilityOffIcon } from '@/components/_primes'


// Component
import { StyledTextField, InputBaseFCProps } from '../Input'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface

export interface PasswordInputFieldBaseFCProps extends InputBaseFCProps {
    isErrorOccured?: boolean
}

interface PasswordInputFieldFCProps extends PasswordInputFieldBaseFCProps, WithTheme {
    isTypePassword?: boolean
    onInputKeyUp?: ReactKeyUpEvent
    onBlur?: StandardInputProps['onBlur'] | FilledInputProps['onBlur'] | OutlinedInputProps['onBlur'];
    onChange?: StandardInputProps['onChange'] | FilledInputProps['onChange'] | OutlinedInputProps['onChange'];
    onFocus?: StandardInputProps['onFocus'] | FilledInputProps['onFocus'] | OutlinedInputProps['onFocus'];
    onClick?: any
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const PasswordInputField = (props: PasswordInputFieldFCProps) => {
    const [isReadOnly, setInputReadyOnly] = useState(true)
    const { isTypePassword, isErrorOccured, onChange, onBlur, onClick, onInputKeyUp, inputProps, InputProps, ...other } = props

    return (
        <StyledTextField
            {...other}
            type={isTypePassword ? 'password' : 'text'}
            aria-describedby="pw-intput"
            data-error={isErrorOccured}
            autoComplete={'new-password'}
            InputProps={{
                error: isErrorOccured,
                onChange,
                onBlur,
                onKeyUp: onInputKeyUp,
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton aria-label="Toggle password visibility" onClick={onClick} data-cy-btn={`${props.id}_toggle_type`}>
                            {isTypePassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                    </InputAdornment>
                ),
                ...InputProps
            }}
            inputProps={{
                'data-error': isErrorOccured,
                readOnly: isReadOnly,
                onKeyDown: () => setInputReadyOnly(false),
                onChange: (e) => {
                    const {
                        currentTarget: { value },
                    } = e
                    setInputReadyOnly(value === '')
                    if (onChange)
                        onChange(e as React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>)
                },
                ...inputProps
            }}
            InputLabelProps={{
                shrink: true,
            }}
        />
    )
}

export default withTheme(PasswordInputField)
